export enum ReasonRefusal {
  GET_REASONS_REFUSAL = 'GET_REASONS_REFUSAL',
  SET_REASON_REFUSAL = 'SET_REASON_REFUSAL',
}

export interface InitialReasonRefusal {
  page: number;
  totalRecords: number;
  rows: [
    {
      reasonRefusalId: string;
      reason: string;
      description: string;
      createdAt: string;
      updatedAt: string;
    },
  ];
  reason: string;
  description: string;
}
